import { z } from 'zod';

import { PrimaryKeySchema, commaDelimitedList } from './utils';

export const SearchEngineRequestSchema = z.object({
  searchEngineRequestId: PrimaryKeySchema,
  query: z.string(),
  createdAt: z.coerce.date(),
});

export type SearchEngineRequest = z.infer<typeof SearchEngineRequestSchema>;

export const SearchEngineRequestsSchema = z.array(SearchEngineRequestSchema);

export type SearchEngineRequests = z.infer<typeof SearchEngineRequestsSchema>;

export const SearchEngineRequestQuerySchema = z.object({
  searchEngineRequestIds: commaDelimitedList(
    PrimaryKeySchema.array(),
  ).optional(),
  queries: commaDelimitedList(z.string().array()).optional(),
});

export type SearchEngineRequestQuery = z.infer<
  typeof SearchEngineRequestQuerySchema
>;
